import React, { Component } from 'react'
import { Card, CardHeader, CardBody, CardFooter, Row, Col} from 'reactstrap'
import { Selector, Header, Nav } from './ManagePane'
import { AddForm } from './'
import { BeatLoader } from 'react-spinners'

class ManageDistrictAdminsAdd extends Component {


  render() {
    const { districts, schools, match, user, history, } = this.props
    const district = this.props.match.params.id

    return (
      <div className='manage-identified add-class'>
        <Row className='org-info-display'>
          <Col xs='12'>
          { user && districts && schools
            ? <Selector
                districts={districts}
                id={match.params.id}
                user={user}
                history={history}
                baseLink='/users/manage/district-admins/add/'
                selectorLevel={'district'}
              />
            : <BeatLoader loading={true} />
          }
        </Col>
        </Row>
          <Row>
            <Col xs='12'>
              <Header>Add a District Admin</Header>
            </Col>
            <Col>
              <AddForm
                id={'district'}
                collection={'educators'}
                role={'District Admin'}
                user={user}
                parentAccount={districts ? districts[district] : {}}
              />
            </Col>
          </Row>

          <Nav back={`/users/manage/district-admins/${district}`} />
      </div>
    )
  }
}

export default ManageDistrictAdminsAdd


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManageDistrictAdminsAdd.js